import styled from 'styled-components';

export const ProgressCircle = /*#__PURE__*/styled.circle.withConfig({ displayName: "ProgressRingstyles__ProgressCircle", componentId: "sc-lu284e-0" })(["transition-property:stroke-dashoffset;transition-duration:", "ms;transition-timing-function:linear;transform:rotate(-90deg);transform-origin:50% 50%;"],

(props) => props.animationDuration ?? 300);